export default interface Feedback {
  feedback: boolean;
  color: string | null;
  text: string | null;
}

const feedbackInitialValue: Feedback = {
  feedback: false,
  color: '',
  text: '',
};

export { feedbackInitialValue };
